import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { AdminCompany } from 'src/modules/companies/types';
import { TintedBox } from './TintedBox.styles';

export default function ValidationBanner({
  company,
  validationInProgress,
  onValidate,
}: {
  company?: AdminCompany;
  validationInProgress: boolean;
  onValidate: () => void;
}) {
  if (!(company && !company.sandBoxMode && company.contactsRequiredValidation > 0)) {
    return null;
  }
  return (
    <TintedBox accent="warning" sx={{ my: 1.25 }}>
      {company?.subscription?.status === 'active' ? (
        <Stack direction="row">
          <Box width="75%" textAlign="center" p={1.25}>
            <Typography variant="body1">
              {`${company?.contactsRequiredValidation} ${
                company?.contactsRequiredValidation === 1 ? 'Contact' : 'Contacts'
              } Pending Validation`}
            </Typography>
            <Typography variant="body1">
              Validate {company?.contactsRequiredValidation === 1 ? 'the contact' : 'these contacts'} to
              prevent unnecessary messaging costs.
            </Typography>
          </Box>
          <Box width="25%" display="flex" justifyContent="center" alignItems="center" height="auto">
            <Button variant="contained" size="small" disabled={validationInProgress} onClick={onValidate}>
              {validationInProgress
                ? 'Validating...'
                : `Validate Contact${company?.contactsRequiredValidation === 1 ? '' : 's'}`}
            </Button>
          </Box>
        </Stack>
      ) : (
        <Box textAlign="center" p={1.25}>
          <Typography variant="body1">
            {`${company?.contactsRequiredValidation} ${
              company?.contactsRequiredValidation === 1 ? 'Contact' : 'Contacts'
            } Pending Validation`}
          </Typography>
        </Box>
      )}
    </TintedBox>
  );
}
